/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "shield-ff50d676--sprite",
  "use": "shield-ff50d676--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"shield-ff50d676--sprite\">\r\n  <defs>\r\n    <clipPath id=\"shield-ff50d676--sprite_clip-Modal_Alert\">\r\n      <rect width=\"36\" height=\"36\" />\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"shield-ff50d676--sprite_Modal_Alert\" clip-path=\"url(#shield-ff50d676--sprite_clip-Modal_Alert)\">\r\n    <g id=\"shield-ff50d676--sprite_Group_19972\" data-name=\"Group 19972\" transform=\"translate(-1310.607 -1426.944)\">\r\n      <g id=\"shield-ff50d676--sprite_Group_19970\" data-name=\"Group 19970\" transform=\"translate(1318.975 1434.05)\">\r\n        <path id=\"shield-ff50d676--sprite_Path_7905\" data-name=\"Path 7905\" d=\"M1337.666,1439.188l-8.063-4.6a1.067,1.067,0,0,0-1.059,0l-8.064,4.6a2.066,2.066,0,0,0-1.039,1.793v2.77a12.133,12.133,0,0,0,5.667,10.343l2.864,1.82a2.054,2.054,0,0,0,2.2,0l2.859-1.819a12.129,12.129,0,0,0,5.671-10.342v-2.77A2.063,2.063,0,0,0,1337.666,1439.188Zm-1.09,1.793v2.774a10.01,10.01,0,0,1-4.681,8.534l-2.778,1.82-2.862-1.821a10.006,10.006,0,0,1-4.677-8.535l-.039-2.707,7.534-4.3Z\" transform=\"translate(-1319.44 -1434.445)\" fill=\"currentColor\" />\r\n        <g id=\"shield-ff50d676--sprite_Group_13010\" data-name=\"Group 13010\" transform=\"translate(8.685 5.68)\">\r\n          <g id=\"shield-ff50d676--sprite_Group_13009\" data-name=\"Group 13009\" transform=\"translate(0 8.535)\">\r\n            <path id=\"shield-ff50d676--sprite_Rectangle_5855\" data-name=\"Rectangle 5855\" d=\"M1329.554,1449.449h0a.948.948,0,0,1,.947.947h0a.948.948,0,0,1-.947.947h0a.947.947,0,0,1-.948-.947h0A.947.947,0,0,1,1329.554,1449.449Z\" transform=\"translate(-1328.607 -1449.449)\" fill=\"currentColor\" />\r\n          </g>\r\n          <path id=\"shield-ff50d676--sprite_Path_4694\" data-name=\"Path 4694\" d=\"M1330.5,1441.387l-.474,5.257a.474.474,0,1,1-.947,0l-.474-5.257a.947.947,0,1,1,1.895,0Z\" transform=\"translate(-1328.607 -1440.44)\" fill=\"currentColor\" />\r\n        </g>\r\n      </g>\r\n    </g>\r\n  </g>\r\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
